import React from 'react'
import "./NavbarContainer.css"
import { Container } from 'react-bootstrap'
import logo from "../../assets/logo.png"
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import enLang from "../../assets/lang.svg"
import arLang from "../../assets/arlang.png"

import { changeLocal } from '../../hooks/Localization';

function NavbarContainer({ scrollToSection }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state?.auth?.userArray?.user);
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const pathSegment = path.split('/').pop();

  const goToSection = (sectionId) => {
    navigate(`/#${sectionId}`);
  };
  const dispatch = useDispatch()
  const handleLang = () => {
    dispatch(
      changeLocal(
        currentLocal.language === "English" ? "ar" : "en"
      )
    );
  }
  
  return (
    <div className='position-fixed bg-white w-100 navbar_container_box' style={{
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <Container>
        <div className='d-flex justify-content-between align-items-center  navbar_container'>
          <div className="logo_container nav_item">
<Link to={"/"}>
            <img src={logo} alt="" className='w-25' />

</Link>
          </div>
          <div className='normalQuery nav_item '>
            <div className='d-flex justify-content-center align-items-center'>
              <li className='  mx-2 text-muted' style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => {
                goToSection("home")

                // if (pathSegment === "login") {
                //   navigate('/');


                // } else {
                // }
              }}>
                <p className="mb-1">{currentLocal.home.home}</p>
              </li>
              <li className=" mx-2 text-muted" style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => {
                if (pathSegment === "login") {
                  navigate('/');


                } else {
                  goToSection("about")
                }
              }
              }>
                <p className="mb-1">{currentLocal.home.aboutafaq}</p>
              </li>
              <li className=" mx-2 text-muted" style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => {
                if (pathSegment === "login") {
                  navigate('/');


                } else {
                  goToSection("features") 
                }
              }}>
                <p className="mb-1">{currentLocal.home.features}</p>
              </li>

              <li className=" mx-2 text-muted" style={{ fontWeight: "500", cursor: "pointer" }} onClick={() => {
                if (pathSegment === "login") {
                  navigate('/');


                } else {
                  navigate('/contact-us');

                }
              }}>
                <p className="mb-1 ">{currentLocal.home.contactUs}</p>
              </li>
              {/* <Link to="/"className='text-muted mx-2'style={{fontWeight:"500"}}>{currentLocal.home.home}</Link>
              <Link to="/about-us"className='text-muted mx-2'style={{fontWeight:"500"}}>{currentLocal.home.aboutafaq}</Link>
              <Link to="/contact-us"className='text-muted mx-2'style={{fontWeight:"500"}}>{currentLocal.home.contacttitle}</Link> */}

            </div>
          </div>
          <div className='nav_item list_container d-flex align-items-center'>
            <div className="nav-item dropdown d-flex justify-content-center align-items-center mx-3">
              <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={currentLocal.language == "English" ? enLang : arLang} alt="" className="w-75" />

                {currentLocal.language}
              </Link>
              <ul className="dropdown-menu">
                <li><div className="dropdown-item  d-flex align-items-center"
                  onClick={handleLang}
                >
                  <img src={currentLocal.language !== "English" ? enLang : arLang} alt="" className="w-25 me-2" />

                  {currentLocal && currentLocal.language === "English" ? "Arabic" : "الانجليزية"
                  }


                </div></li>
              </ul>
            </div>
            <button className='border-0 bg_main py-2 px-4 rounded text-white' onClick={() => {
              if(userinfo){
                if(userinfo?.role=="Student"){
 if (!userinfo?.student?.register_fee_image) {
   navigate("/payment");
 }else{
                     navigate( "/dashboard/Dashboard")

 }
                }else{
                   navigate( "/dashboard/Dashboard")
                }

              }else{
                navigate("/login")
              }
              // if (!userinfo?.student?.register_fee_image) {
              //   navigate(userinfo?"/payment":"/login");

              // } else {
              //   navigate(userinfo ? "/dashboard/Dashboard" : "/login")

              // }
            }}>
              {userinfo ? userinfo?.name : currentLocal.home.login}
            </button>


          </div>
        </div>
      </Container>
    </div>
  )
}

export default NavbarContainer